<template>
  <div>
    <b-modal
      id="send-alert-confirmation"
      title="Alert confirmation"
      hide-footer
    >
      <h3>Are you sure you want to send an Alert?</h3>

      <div class="d-flex mt-2">
        <b-button
          class="mr-2"
          block
          variant="primary"
          :disabled="submitting"
          @click="submitAlert"
        >
          <b-spinner
            v-if="submitting"
            small
          />
          <span v-else>Yes</span>
        </b-button>
        <b-button
          block
          :disabled="submitting"
          variant="danger"
          @click="$bvModal.hide('send-alert-confirmation')"
        >
          No
        </b-button>
      </div>
    </b-modal>
    <b-modal
      id="send-alert-modal"
      :title="`Send alert to ${driver.fullName}`"
      hide-footer
    >
      <validation-observer ref="formRef">
        <b-form
          autocomplete="off"
          class="p-2"
        >
          <validation-provider
            #default="validationContext"
            name="Description"
            rules="required"
          >
            <b-form-group
              label="Description"
              label-for="description"
            >
              <b-form-textarea
                id="description"
                v-model="alertForm.description"
                placeholder="Enter description"
              />
              <small class="text-danger">{{ validationContext.errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <b-button
            :disabled="!alertForm.description"
            variant="danger"
            @click="$bvModal.show('send-alert-confirmation')"
          >
            Send Alert
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import {
  BFormTextarea, BForm, BFormGroup, BButton, BSpinner, BModal,
} from 'bootstrap-vue'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BForm,
    BFormGroup,
    BButton,
    BSpinner,
  },
  props: {
    driver: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const user = computed(() => ctx.root.$store.getters['auth/getLoggedUser'])
    const alertForm = ref({
      driver: ctx.root.$router.currentRoute.params.id,
      inactivationReason: '4354f3d7-63bd-4138-945d-77932b2cdc96',
      createdBy: user.value.email,
      alert: true,
      description: '',
    })
    const submitting = ref(false)
    const submitAlert = async () => {
      try {
        submitting.value = true
        await ctx.root.$store.dispatch('driverView/createDriverInactivation', alertForm.value)
        alertForm.value.description = ''
        successNotification('Alert Sent successfully')
        ctx.root.$bvModal.hide('send-alert-confirmation')
        ctx.root.$bvModal.hide('send-alert-modal')
        await ctx.root.$store.dispatch('driverView/fetchDriverInactivationList', {
          id: ctx.root.$router.currentRoute.params.id,
          isResolvedInactivation: true,
        })

        await ctx.root.$store.dispatch('driverView/fetchDriverInactivationList', {
          id: ctx.root.$router.currentRoute.params.id,
          isResolvedInactivation: false,
        })
      } catch (err) {
        errorNotification('An error occured')
      } finally {
        submitting.value = false
      }
    }

    return {
      alertForm,
      submitting,
      submitAlert,
      required,
    }
  },
}
</script>
